import { MinzeElement } from 'minze'

export interface LvcToastSuccessIcon {}

export class LvcToastSuccessIcon extends MinzeElement {
  html = () => `
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#DCFFD7"/>
      <path d="M23 11C19.9121 14.0326 16.8438 17.4123 13.9345 20.639C13.7532 20.84 13.4447 20.8602 13.2389 20.6844C11.5946 19.2798 10.3973 18.2079 9 16.439" stroke="#1E007D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
    
  `
}
